var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSecure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#01A96E",
  fillRule: "evenodd",
  d: "M11.347 0 22.44 4.843q-.007.66-.016.98Q22.087 19 11.44 23 1.148 19 .487 5.946.469 5.584.44 4.843zm.153 6a2.5 2.5 0 0 0-1.196 4.696l-.934 5.263h4.26l-.934-5.263A2.5 2.5 0 0 0 11.5 6"
})));
export { SvgIconSecure as ReactComponent };
export default __webpack_public_path__ + "img/icon-secure.f65f56d94cfe9f5a3f4a9b2b539b1b71.svg";